import { h } from 'preact';
export const SkipBack = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("polygon", { points: "19 20 9 12 19 4 19 20" }),
        h("line", { x1: "5", y1: "19", x2: "5", y2: "5" })));
};
//# sourceMappingURL=skip-back.js.map